import type {ToolHeaderPropsType} from './NewToolHeader'
import {CodeInsightsIndicator} from './code-insights/CodeInsights'
import type {ToolLogMetadataBag} from '../../../types/tool-log-metadata'

/**
 * Creates tool header props with an optional trailing visual for code insights.
 */
export function createToolHeaderProps(
  baseProps: ToolHeaderPropsType,
  metadata: ToolLogMetadataBag | undefined,
  shouldShowCodeInsights: boolean,
): ToolHeaderPropsType {
  const result: ToolHeaderPropsType = {...baseProps}

  if (shouldShowCodeInsights) {
    const codeInsights = metadata?.['code-insights']
    if (codeInsights && codeInsights.publicCodeReferences.length > 0) {
      result.trailingVisual = <CodeInsightsIndicator insights={codeInsights} />
    }
  }

  return result
}
